import { Route, Routes } from "react-router-dom";
import UsersPage from "./pages/user";
import Layout from "./layout";
import CostCenterPage from "./pages/cost_center";
import LoginPage from "./pages/login";
import AuthMiddleware from "./middlewares/auth";
import AdministradorMiddleware from "./middlewares/users";
import CreateUserPage from "./pages/user/create";
import CreateCostCenterPage from "./pages/cost_center/create";
import TypesPage from "./pages/types";
import CreateTypePage from "./pages/types/create";
import StatesPage from "./pages/states";
import CitiesPage from "./pages/cities";
import CostCentersInfoPage from "./pages/cost_center/info";
import ApproversMiddleware from "./middlewares/approvers";
import ApproversAllOrdersPage from "./pages/approvers/orders/all";
import ApproversInfoOrdersPage from "./pages/approvers/orders/all/info";
import ApproversPendingOrdersPage from "./pages/approvers/orders/pending";
import ApproversDashboardPage from "./pages/approvers/dashboard";
import UsersUpdatePage from "./pages/user/update";
import UsersManagersPage from "./pages/user/managers";
import UsersManagersInfoPage from "./pages/user/managers/info";
import ManagersMiddleware from "./middlewares/manager";
import ManagersCostCentersPage from "./pages/managers/cost_centers";
import ManagersCostCentersInfoPage from "./pages/managers/cost_centers/info";
import ManagersEmployeesPage from "./pages/managers/employees";
import ManagersOrdersPage from "./pages/managers/orders";
import ManagersInfoOrdersPage from "./pages/managers/orders/info";
import ManagersEmployeesUpdatePage from "./pages/managers/employees/edit";
import FinancialDashboardPage from "./pages/financial/dashboard";
import FinancialMiddleware from "./middlewares/financial";
import FinancialOrdersPage from "./pages/financial/orders";
import FinancialOrdersInfoPage from "./pages/financial/orders/info";
import ProfilePage from "./pages/profile";
import ManagersDashboardPage from "./pages/managers/dashboard";
import ManagersCostCenterEmployeesPage from "./pages/managers/cost_centers/employees";
import FinancialEmailsPage from "./pages/financial_emails";

const SystemRoutes = () => {

    return (
        <Routes>

            <Route path="/" element={<LoginPage />} />

            {/* rotas para usuários logados */}
            <Route element={<AuthMiddleware />}>
                <Route element={<Layout />}>

                    <Route path="/profile" element={<ProfilePage />} />

                    {/* rotas para usuários administardores */}
                    <Route element={<AdministradorMiddleware />}>

                        {/* rotas para a parte de usuários */}
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/users/create" element={<CreateUserPage />} />
                        <Route path="/users/:id" element={<UsersUpdatePage />} />
                        <Route path="/users/managers" element={<UsersManagersPage />} />
                        <Route path="/users/managers/:id" element={<UsersManagersInfoPage />} />
                        {/* rotas para a parte de usuários */}

                        {/* rotas para a parte de centros de custo */}
                        <Route path="/cost_centers" element={<CostCenterPage />} />
                        <Route path="/cost_centers/create" element={<CreateCostCenterPage />} />
                        <Route path="/cost_centers/:id" element={<CostCentersInfoPage />} />
                        {/* rotas para a parte de centros de custo */}

                        {/* rotas para a parte de tipos */}
                        <Route path="/types" element={<TypesPage />} />
                        <Route path="/types/create" element={<CreateTypePage />} />
                        {/* rotas para a parte de tipos */}

                        {/* rotas para estados */}
                        <Route path="/states" element={<StatesPage />} />
                        {/* rotas para estados */}

                        {/* rotas para cidades */}
                        <Route path="/cities" element={<CitiesPage />} />
                        {/* rotas para cidades */}

                        {/* rotas para os e-mails do financeiro */}
                        <Route path="/financial_emails" element={<FinancialEmailsPage />} />
                        {/* rotas para os e-mails do financeiro */}

                    </Route>
                    {/* rotas para usuários administardores */}

                    {/* rotas para usuário aprovadores */}
                    <Route element={<ApproversMiddleware />}>
                        <Route path="/approvers/dashboard" element={<ApproversDashboardPage />} />
                        <Route path="/approvers/orders" element={<ApproversAllOrdersPage />} />
                        <Route path="/approvers/orders/pending" element={<ApproversPendingOrdersPage />} />
                        <Route path="/approvers/orders/:id" element={<ApproversInfoOrdersPage />} />
                        <Route path="/approvers/orders/exportrdi" element={<ApproversInfoOrdersPage />} />
                    </Route>
                    {/* rotas para usuário aprovadores */}

                    {/* rotas para usuários gerentes */}
                    <Route element={<ManagersMiddleware />}>
                        <Route path="/managers/dashboard" element={<ManagersDashboardPage />} />

                        <Route path="/managers/cost_centers" element={<ManagersCostCentersPage />} />
                        <Route path="/managers/cost_centers/:id" element={<ManagersCostCentersInfoPage />} />
                        <Route path="/managers/cost_centers/employees/:id" element={<ManagersCostCenterEmployeesPage />} />

                        <Route path="/managers/employees" element={<ManagersEmployeesPage />} />
                        <Route path="/managers/employees/:id" element={<ManagersEmployeesUpdatePage />} />

                        <Route path="/managers/orders" element={<ManagersOrdersPage />} />
                        <Route path="/managers/orders/:id" element={<ManagersInfoOrdersPage />} />
                        <Route path="/approvers/orders/exportrdi" element={<ManagersInfoOrdersPage />} />
                    </Route>
                    {/* rotas para usuários gerentes */}

                    {/* rotas para usuários financeiros */}
                    <Route element={<FinancialMiddleware />}>
                        <Route path="/financial/dashboard" element={<FinancialDashboardPage />} />
                        <Route path="/financial/orders" element={<FinancialOrdersPage />} />
                        <Route path="/financial/orders/:id" element={<FinancialOrdersInfoPage />} />
                    </Route>
                    {/* rotas para usuários financeiros */}

                </Route>
            </Route>
            {/* rotas para usuários logados */}
        </Routes>
    )

}

export default SystemRoutes;